import { FC } from 'react'
import addBadge from 'src/assets/addBadge.svg'
import BadgeSelect from './BadgeSelect'
import Popout from '../Popout'
import { BadgeName } from 'src/app/types'
import { DEFAULT_BADGES } from 'src/constant'

type AddBadgeProps = { onClick: (arg: BadgeName) => void }

const AddBadge: FC<AddBadgeProps> = ({ onClick }) => {
  return (
    <Popout
      popoutClass="z-[60]"
      placement="bottom-end"
      dismissFloatingEnabled
      contents={<BadgeSelect onClickBadge={onClick} badges={DEFAULT_BADGES} />}
    >
      {({ isOpen }) => (
        <button
          aria-label="add a badge"
          className={`inline-flex rounded p-2 ${isOpen ? 'bg-lightGrey' : ''}`}
        >
          <img alt="add badge" src={addBadge} />
        </button>
      )}
    </Popout>
  )
}

export default AddBadge
